"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SCALE_PRESENTER_BANNERS_ON_CAMERAS_EXCEEDING = exports.PRESENTER_BANNER = exports.MAX_PRESENTER_BANNERS_CHARACTERS = exports.HIDE_DESCRIPTION_ON_COUNT_EXCEEDING = exports.BANNER_TEMPLATE = exports.BANNER_PLACEHOLDERS = exports.BANNER_ANIMATION_STYLES = void 0;
var _SourceItems = require("./SourceItems");
var BANNER_ANIMATION_STYLES = exports.BANNER_ANIMATION_STYLES = ['Slide Right', 'Slide Left', 'Slide Up', 'Wipe Right', 'Wipe Left', 'Wipe Up', 'Dissolve In', 'Instant'];
var PRESENTER_BANNER = exports.PRESENTER_BANNER = 'presenterBanner';
var BANNER_TEMPLATE = exports.BANNER_TEMPLATE = {
  title: '{bannerName}',
  value: {
    templateId: '',
    templateVars: {
      LINE_1: 'Presenter name',
      LINE_2: 'Presenter title',
      ACCENT_COLOR: '#FFEA7F'
    },
    autoLeave: false,
    transitionStyle: '',
    templateType: ''
  },
  type: _SourceItems.BANNER
};
var BANNER_PLACEHOLDERS = exports.BANNER_PLACEHOLDERS = {
  title: 'Presenter name',
  description: 'Presenter title'
};
var HIDE_DESCRIPTION_ON_COUNT_EXCEEDING = exports.HIDE_DESCRIPTION_ON_COUNT_EXCEEDING = 6;
var SCALE_PRESENTER_BANNERS_ON_CAMERAS_EXCEEDING = exports.SCALE_PRESENTER_BANNERS_ON_CAMERAS_EXCEEDING = 5;
var MAX_PRESENTER_BANNERS_CHARACTERS = exports.MAX_PRESENTER_BANNERS_CHARACTERS = 20;